import { useMemo } from 'react';

import { DataType } from '@atom/types/dataType';

import CustomFieldCell from './CustomFieldCell';
import { MappedField } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  fields: MappedField[];
}

const CustomFieldRow = ({ fields }: Props) => {
  const isTitleField = useMemo(() => {
    const isSummary = fields[0].dataType === DataType.SUMMARY;

    return isSummary && fields.length === 1;
  }, [fields]);

  return (
    <div className={classes.customFieldRow}>
      {fields.map(field => (
        <CustomFieldCell
          key={field?.id}
          field={field}
          isTitleField={isTitleField}
        />
      ))}
    </div>
  );
};

export default CustomFieldRow;
